import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Particles from 'react-particles-js';

import { particlesConfig } from '../helpers/particles-config';

const Hero = forwardRef(
  ({ children, className, compact, contrast, particles, ...props }, ref) => {
    const classes = cx(
      'hero',
      {
        'hero--compact': compact,
        'u-contrast': contrast,
      },
      className
    );

    return (
      <section className={classes} ref={ref} {...props}>
        {particles && (
          <Particles
            params={particlesConfig}
            className="hero-particlesWrapper"
          />
        )}
        {children}
      </section>
    );
  }
);

Hero.propTypes = {
  compact: PropTypes.bool,
  contrast: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  particles: PropTypes.bool,
};

Hero.defaultProps = {
  contrast: true,
  particles: true,
};

export default Hero;
